import React from "react";

const SimpleDivComponent = ({ text, backgroundColor }) => {
  const divStyle = {
    backgroundColor: backgroundColor || "#abcd52",
    padding: "30px",
  };

  return (
    <div style={divStyle}>
      <h3
        style={{
          fontFamily: "Fredoka One",
          textAlign: "center",
          color: "white",
          fontSize: "36px",
        }}
      >
        {text}
      </h3>
    </div>
  );
};

export default SimpleDivComponent;
